// extracted by mini-css-extract-plugin
module.exports = {"title":"CollapseDiv_title__24_3v","content":"CollapseDiv_content__2Flpg","container":"CollapseDiv_container__kbJah"};